export { asRecord } from "@/lib/structuredValue";

export function withRefreshToken(endpoint: string, refreshToken: number) {
  const normalizedToken =
    typeof refreshToken === "number" && Number.isFinite(refreshToken)
      ? Math.max(0, Math.trunc(refreshToken))
      : 0;
  if (normalizedToken <= 0) return endpoint;
  return `${endpoint}${endpoint.includes("?") ? "&" : "?"}refresh=${normalizedToken}`;
}

export function hasRequiredMethods(
  value: unknown,
  requiredMethods: readonly string[],
) {
  if (!value || typeof value !== "object") return false;

  const candidate = value as Record<string, unknown>;
  return requiredMethods.every(
    (methodName) => typeof candidate[methodName] === "function",
  );
}

export function describeAvailableMethods(
  value: unknown,
  methods: readonly string[],
) {
  const candidate =
    value && typeof value === "object" ? (value as Record<string, unknown>) : {};

  return Object.fromEntries(
    methods.map((methodName) => [
      methodName,
      typeof candidate[methodName] === "function",
    ]),
  );
}
